module.exports = __webpack_public_path__ + "static/media/heartDisease.a050ac48.mp3";